import { render, staticRenderFns } from "./ShowRoles.vue?vue&type=template&id=38b98b01"
import script from "./ShowRoles.vue?vue&type=script&lang=js"
export * from "./ShowRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports